<template>
    <v-dialog v-model="isOpen" max-width="400">
        <div class="dialogClose">
            <div v-on:mousedown.prevent="isOpen = false" v-on:touchstart.prevent="isOpen = false"><img
                    src="/images/common/close.png" /></div>
        </div>
        <v-card class="dialogBase dialogMain">
            <v-card-text>
                <div class="text-center dialogHtpTitle windowTitle">写真を撮影する</div>
                <v-row class="text-center" v-show="!isArchives">


                    <v-col cols="12" class="text-center ma-0 pa-0 flickArea" v-if="nowFrameNum <= 1">
                        <div class="flickdiv" v-if="isOkA">
                            <img ref="capImageA" width="100%" src="/images/frame/frame_dummy.png"
                                style="background-color:#aaa" />
                            <div class="frameName">{{ $store.getters.dataFrameA.name }}</div>
                        </div>
                        <div class="flickdiv" v-if="isOkB">
                            <img ref="capImageB" width="100%" src="/images/frame/frame_dummy.png"
                                style="background-color:#aaa" />
                            <div class="frameName">{{ $store.getters.dataFrameB.name }}</div>
                        </div>
                        <div class="flickdiv" v-if="isOkC">
                            <img ref="capImageC" width="100%" src="/images/frame/frame_dummy.png"
                                style="background-color:#aaa" />
                            <div class="frameName">{{ $store.getters.dataFrameC.name }}</div>
                        </div>
                    </v-col>
                    <v-col cols="12" class="text-center ma-0 pa-0 flickArea" v-else>
                        <Flicking :options="{ circular: true }" ref="flick" @move="dialogMove"
                            @move-start="dialogMoveStart" @move-end="dialogMoveEnd">
                            <div class="flickdiv" v-if="isOkA">
                                <img ref="capImageA" width="100%" src="/images/frame/frame_dummy.png"
                                    style="background-color:#aaa" />
                                <div class="frameName">{{ $store.getters.dataFrameA.name }}</div>
                            </div>
                            <div class="flickdiv" v-if="isOkB">
                                <img ref="capImageB" width="100%" src="/images/frame/frame_dummy.png"
                                    style="background-color:#aaa" />
                                <div class="frameName">{{ $store.getters.dataFrameB.name }}</div>
                            </div>
                            <div class="flickdiv" v-if="isOkC">
                                <img ref="capImageC" width="100%" src="/images/frame/frame_dummy.png"
                                    style="background-color:#aaa" />
                                <div class="frameName">{{ $store.getters.dataFrameC.name }}</div>
                            </div>
                        </Flicking>

                        <div id="flickNextBtn" class="flickBtnArea">
                            <img src="/images/puzzle/btn_next.png" v-on:mousedown.prevent="flickNext"
                                v-on:touchstart.prevent="flickNext" />
                        </div>
                        <div id="flickPrevBtn" class="flickBtnArea">
                            <img src="/images/puzzle/btn_prev.png" v-on:mousedown.prevent="flickPrev"
                                v-on:touchstart.prevent="flickPrev" />
                        </div>
                        <div id="flickIcon" class="flickBtnArea flickBtnIcon">
                            <img src="/images/puzzle/flick_icon.png" />
                        </div>
                    </v-col>

                    <v-col cols="3" class="pa-0" v-on:mousedown.prevent="switchCamera"
                        v-on:touchstart.prevent="switchCamera">
                        <img src="/images/common/switchcamera.png" class="switchCamera" />
                    </v-col>
                    <v-col cols="6" class="pa-0">
                        <v-btn class="btn_blue" @click="execShot" v-on:mousedown.prevent="execShot"
                            v-on:touchstart.prevent="execShot" :disabled="!isActiveCamera">
                            撮影する
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row class="text-center mb-3" v-show="isArchives">
                    <v-col cols="12" class="text-center ma-0 pa-0">
                        <img ref="shotImage" width="77%" src="" style="background-color:#aaa;margin-top: 2%;" />
                    </v-col>
                    <v-col cols="12" class="pa-0">
                        画像を長押しすると保存出来るよ！
                    </v-col>
                    <v-col cols="2" class="pa-0">
                    </v-col>
                    <v-col cols="8" class="pa-0">
                        <v-btn class="btn_blue" @click="isArchives = false">
                            再撮影
                        </v-btn>
                    </v-col>
                    <v-col cols="2" class="pa-0">
                    </v-col>

                </v-row>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.frameName {
    font-family: 'Noto Sans JP', sans-serif;
    font-weight: bold;
}

.flickdiv {
    width: 100%;
    padding-top: min(3vw, 18px);
    padding-left: min(7vw, 42px);
    padding-right: min(7vw, 42px);
    padding-bottom: min(3vw, 18px);
    font-size: min(5vw, 18px);
}

.flickArea {
    position: relative;
}

.flickBtnArea {
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.flickBtnArea img {
    width: min(8vw, 28px);
    margin: min(1vw, 18px);
    z-index: 1;
}

.flickBtnIcon img {
    width: min(8vw, 48px) !important;
    margin-right: min(8vw, 40px);
    border: 1px solid #FFFFFF;
}

#flickNextBtn {
    justify-content: flex-end;
    align-items: center;
}

#flickPrevBtn {
    justify-content: flex-start;
    align-items: center;
}

#flickIcon {
    margin-top: min(1vw, 8px);
    justify-content: flex-end;
    align-items: end;
}

.btn_blue {
    color: #FFFFFF !important;
    background-color: #0F9DE8 !important;
    box-shadow: 4px 3px #096291;
    border-radius: 100vh;
    width: 80%;
    height: 2.3em !important;
    padding-top: min(1vw, 3px) !important;
    font-size: min(5vw, 20px) !important;
    font-weight: bold !important;
}

.btn_blue:disabled {
    box-shadow: 4px 3px #999999;
}

.switchCamera {
    height: min(13vw, 48px);
}
</style>
<script>

import '@/assets/style/window.css';

export default {
    data: () => ({
        isOpen: true,
        isActiveCamera: false,
        isOkA: false,
        isOkB: false,
        isOkC: false,
        isArchives: false,
        frameDataA: undefined,
        frameDataB: undefined,
        frameDataC: undefined,
        nowFrameNum: 0,
        // isBtnDisabled: true
    }),
    props: {
    },
    created: function () {

        this.frameDataA = this.$store.getters.dataFrameA;
        this.frameDataB = this.$store.getters.dataFrameB;
        this.frameDataC = this.$store.getters.dataFrameC;

        let nowPiece = this.$store.getters.nowPiece;
        console.log(nowPiece);
        if (this.frameDataA && nowPiece.a[0] && nowPiece.a[1]) {
            this.isOkA = true;
            this.nowFrameNum++;
        }
        if (this.frameDataB && nowPiece.b[0] && nowPiece.b[1] && nowPiece.b[2] && nowPiece.b[3]) {
            this.isOkB = true;
            this.nowFrameNum++;
        }
        if (this.frameDataC && nowPiece.c[0]) {
            this.isOkC = true;
            this.nowFrameNum++;
        }

        // 表示するフレームがない場合
        if (this.nowFrameNum == 0) {
            this.isOpen = false;
        }

        setTimeout(() => {
            if (this.frameDataA && this.$refs.capImageA) this.$refs.capImageA.src = this.frameDataA.frame;
            if (this.frameDataB && this.$refs.capImageB) this.$refs.capImageB.src = this.frameDataB.frame;
            if (this.frameDataC && this.$refs.capImageC) this.$refs.capImageC.src = this.frameDataC.frame;
            if (this.isOkA) {
                this.viewShot("a");
            } else if (this.isOkB) {
                this.viewShot("b");
            } else if (this.isOkC) {
                this.viewShot("c");
            }
        }, 100);
    },
    destroyed: function () {
        this.$stamp.stopCamera();
    },
    methods: {
        async changeShotFrame(frameId, count) {
            await this.viewShot(frameId, count, true)
        },
        async viewShot(frameId, count, isFrameChange) {
            console.log(frameId);
            let frameData;
            let capImage;


            const loadImage = function (src) {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.onload = () => resolve(img);
                    img.onerror = (e) => reject(e);
                    img.src = src;
                });
            }
            let targetImageList = [];
            if (this.$refs.capImageA && this.frameDataA) {
                targetImageList.push({ "target": this.$refs.capImageA, "frameImg": await loadImage(this.frameDataA.frame) })
            }
            if (this.$refs.capImageB && this.frameDataB) {
                targetImageList.push({ "target": this.$refs.capImageB, "frameImg": await loadImage(this.frameDataB.frame) })
            }
            if (this.$refs.capImageC && this.frameDataC) {
                targetImageList.push({ "target": this.$refs.capImageC, "frameImg": await loadImage(this.frameDataC.frame) })
            }

            switch (frameId) {
                case "a":
                    frameData = this.frameDataA;
                    capImage = this.$refs.capImageA;
                    if (this.frameDataB && this.$refs.capImageB) this.$refs.capImageB.src = this.frameDataB.frame;
                    if (this.frameDataC && this.$refs.capImageC) this.$refs.capImageC.src = this.frameDataC.frame;
                    break;
                case "b":
                    frameData = this.$store.getters.dataFrameB;
                    capImage = this.$refs.capImageB;
                    if (this.frameDataA && this.$refs.capImageA) this.$refs.capImageA.src = this.frameDataA.frame;
                    if (this.frameDataC && this.$refs.capImageC) this.$refs.capImageC.src = this.frameDataC.frame;

                    break;
                case "c":
                    frameData = this.$store.getters.dataFrameC;
                    capImage = this.$refs.capImageC;
                    if (this.frameDataA && this.$refs.capImageA) this.$refs.capImageA.src = this.frameDataA.frame;
                    if (this.frameDataB && this.$refs.capImageB) this.$refs.capImageB.src = this.frameDataB.frame;
                    break;
            }
            if (!frameData) return;

            if (!count) count = 1;
            if (capImage) {
                try {
                    this.isActiveCamera = false;

                    await this.$stamp.shotCamera(capImage, frameData.frame, (event) => {
                        this.isActiveCamera = true;
                    }, isFrameChange, targetImageList)
                } catch (error) {
                    console.error(error);
                    this.$router.push({ name: 'error', params: { 'errormessage': "カメラが利用ができません。" } });
                }
            } else if (count < 5) {
                setTimeout(() => {
                    this.viewShot(frameId, count + 1, isFrameChange)
                }, 300);
            }
        },
        switchCamera() {
            this.isActiveCamera = false;
            this.$stamp.switchCamera(() => {
                this.isActiveCamera = true;
                // this.isBtnDisabled = false;
            });
        },
        execShot() {
            try {
                this.arcivesBase64 = this.$stamp.getShotCameraData();
                if (!this.arcivesBase64) throw new Error("not image");
                this.isArchives = true;
                this.viewArchiveShot();
            } catch (error) {
                console.log(error);
            }
        },
        viewArchiveShot(count) {
            if (!count) count = 1;
            if (this.$refs.shotImage) {
                this.$refs.shotImage.src = this.arcivesBase64;
            } else if (count < 5) {
                setTimeout(() => {
                    this.viewArchiveShot(count + 1)
                }, 300);
            }
        },

        dialogMove(e) {
            // console.log(e);
        },
        dialogMoveStart(e) {
            this.isActiveCamera = false;

            // this.isBtnDisabled = true;

            // this.$stamp.stopCamera();
        },
        dialogMoveEnd(e) {
            setTimeout(() => {
                let nowNum = e.currentTarget.index;

                switch (nowNum) {
                    case 0:
                        if (this.isOkA) {
                            this.changeShotFrame("a");
                        } else if (this.isOkB) {
                            this.changeShotFrame("b");
                        } else if (this.isOkC) {
                            this.changeShotFrame("c");
                        }
                        break;
                    case 1:
                        if (this.isOkA) {
                            if (this.isOkB) {
                                this.changeShotFrame("b");
                            } else if (this.isOkC) {
                                this.changeShotFrame("c");
                            }
                        } else {
                            if (this.isOkB) {
                                this.changeShotFrame("c");
                            }
                        }
                        break;
                    case 2:
                        this.changeShotFrame("c");
                        break;
                }
                // this.isBtnDisabled = false;
            }, 100);

        },
        flickNext() {
            this.$refs.flick.next();
        },
        flickPrev() {
            this.$refs.flick.prev();
        },
    },
    computed: {

    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.$emit('close');
                this.$stamp.stopCamera();
            }
        }
    }
}
</script>